module.exports = __webpack_public_path__ + "static/media/logo-kitchen-sink.f1ebd230.png";